module.exports = __webpack_public_path__ + "static/alexfid-f5a5b1c96dc969a8b55f6df66a2f6f9a.jpg";